/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";

export interface IThorSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    sticky:ISymbolStateConfig;
    land_1:ISymbolStateConfig;
    idleScatter_1:ISymbolStateConfig;
    attention:ISymbolStateConfig;
    idleScatter_2:ISymbolStateConfig;
    nudgeOut:ISymbolStateConfig;
    nudgeOutReversed:ISymbolStateConfig;
    initialWin:ISymbolStateConfig;
    spinGlow:ISymbolStateConfig;
    lit:ISymbolStateConfig;
}

export class ThorReelSymbol extends StateReelSymbol {

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, 0, state);
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        /*
        if(newState.state.keyword === ThorGameConfig.instance.SYMBOL_STATES.win.keyword) {
            const winTl:TimelineLite = new TimelineLite();
            winTl.add(new TweenLite(this.scale, 0.2, {x : 1.2, y : 1.2}));
            winTl.add(() => new TweenLite(this.scale, 0.2, {x : 1, y : 1, delay : 0.3}));
            timeline.add(winTl, delay);
            return;
        }
        */
    }
}